export default __webpack_public_path__ + "static/media/hero.ef53dc2c.jpg";